
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 6.5a.5.5 0 00.5.5.5.5 0 01.5.5v2.696c0 .444-.36.804-.804.804-.287 0-.543.162-.74.371A1.994 1.994 0 0119 12a1.993 1.993 0 01-1.376-.549c-.26-.245-.576-.451-.933-.451H7.309c-.357 0-.674.206-.933.451-.358.34-.843.549-1.376.549a1.993 1.993 0 01-1.376-.549c-.26-.245-.576-.451-.933-.451H1.84a1 1 0 01-.825-1.566L1.76 8.35a1 1 0 01.66-.42l5.265-.877a1 1 0 00.543-.28l1.67-1.67a.353.353 0 11.497.5l-.4.397a.584.584 0 00.41 1h2.875a1 1 0 00.949-.684l.164-.492a.474.474 0 11.9.3l-.108.325A.419.419 0 1016 6.58V6.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5z","fill":"currentColor"}})])
          )
        }
      }
    